import React from 'react'
import styled from 'styled-components'
import { Link } from '@olxbr/ds-web'
import PropTypes from 'prop-types'

import Shield from '@olxbr/olx-icons/dist/System/Shield'
import Clipboard from '@olxbr/olx-icons/dist/System/Clipboard'
import Bell from '@olxbr/olx-icons/dist/System/Bell'
import Award from '@olxbr/olx-icons/dist/System/Award'

const Nav = styled.nav``

const Ul = styled.ul`
  list-style-type: none;
  margin: var(--spacing-0-5) 0;
`

const Li = styled.li`
  margin: 0;
`

const LinkBoxOfSideMenuItem = styled(Link)`
  font-weight: var(--font-weight-regular);
  width: 100%;
  height: 48px;
  padding-left: var(--spacing-4);
  justify-content: flex-start;

  color: var(--color-neutral-130);

  & > svg {
    margin-right: var(--spacing-3);
  }

  &:hover {
    text-decoration: none;
  }

  &[aria-current='page'] {
    color: var(--color-secondary-100);
    background-color: #f3eef5;
    border-radius: 25px;
  }
`

const SideMenuWrapper = styled.div`
  flex: 1;
  width: 287px;
`

export class SideMenu extends React.PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      selectedMenu: props.selectedMenu,
    }
  }

  render() {
    const { selectedMenu } = this.state

    const clickMenu = (ev, menuSelection) => {
      ev.preventDefault()
      this.setState({ selectedMenu: menuSelection })
      window.location.href = `${window.location.origin}/${menuSelection}`
    }

    const myAccount = 'meu-cadastro'
    const security = 'seguranca'
    const comunications = 'comunicacoes'
    const myLevel = 'meu-nivel'

    return (
      <SideMenuWrapper>
        <Nav {...this.props}>
          <Ul>
            <Li>
              <LinkBoxOfSideMenuItem
                onClick={ev => clickMenu(ev, myAccount)}
                href={`/${myAccount}`}
                aria-current={selectedMenu === myAccount ? 'page' : 'false'}
                size="medium"
              >
                <Clipboard width={24} height={24} />
                Meu cadastro
              </LinkBoxOfSideMenuItem>
            </Li>
            <Li>
              <LinkBoxOfSideMenuItem
                onClick={ev => clickMenu(ev, security)}
                href={`/${security}`}
                aria-current={selectedMenu === security ? 'page' : 'false'}
                size="medium"
              >
                <Shield width={24} height={24} />
                Segurança e privacidade
              </LinkBoxOfSideMenuItem>
            </Li>
            <Li>
              <LinkBoxOfSideMenuItem
                onClick={ev => clickMenu(ev, comunications)}
                href={`/${comunications}`}
                aria-current={selectedMenu === comunications ? 'page' : 'false'}
                size="medium"
              >
                <Bell width={24} height={24} />
                Comunicações
              </LinkBoxOfSideMenuItem>
            </Li>
            <Li>
              <LinkBoxOfSideMenuItem
                onClick={ev => clickMenu(ev, myLevel)}
                href={`/${myLevel}`}
                aria-current={selectedMenu === myLevel ? 'page' : 'false'}
                size="medium"
              >
                <Award width={24} height={24} />
                Meu nível
              </LinkBoxOfSideMenuItem>
            </Li>
          </Ul>
        </Nav>
      </SideMenuWrapper>
    )
  }
}

SideMenu.defaultProps = {
  selectedMenu: 'meu-cadastro',
}

SideMenu.propTypes = {
  selectedMenu: PropTypes.string,
}
